<style scoped>

	iframe {
		height:1000px;
		width:1600px;
	}
</style>
<template>
<tr v-bind:class="{ 'line-item': !line.epic && !line.group && !line.story }">
	<th v-if="line.group">
		<i class="far fa-bars float-start dragRow"></i>
        <span class="tag text-truncate">{{line.group.text}}<i class="far fa-times" role="button" @click="confirmRemoveGroup(line.group.id)"></i></span>
	</th>

    <th :alt="line.epic.title" class="text-truncate" v-else-if="line.epic">
		<i class="far fa-bars float-start dragRow"></i>
		{{line.epic.title}}
	</th>

    <th :alt="line.story.title" class="text-truncate" v-else-if="line.story">
		<i class="far fa-bars float-start dragRow"></i>
		{{line.story.title}}
	</th>

	<th v-else>
		<span v-show="line.order == 0">{{line.name}}</span>
		<input class="form-input feature-name" v-model="line.name" @blur="save" v-show="line.order != 0">
        <span v-show="line.order != 0"><i class="far fa-times" role="button" @click="confirmRemoveFeature()"></i></span>
	</th>
	<td>{{line.base_effort}}</td>
	<td>{{line.hours}}</td>
	<td class="minor">{{line.bugs}}</td>
	<td class="minor">{{line.management}}</td>
	<td class="strong">{{line.total_hours}}</td>

	<td class="cost">$ {{line.total_ex | currency}}</td>
</tr>
</template>

<script>
    //http://stackoverflow.com/documentation/javascript/4742/same-origin-policy-cross-origin-communication/30128/safe-cross-origin-communication-with-messages#t=201705171403471400655
//<div id="iframe-wrapper" style="position: absolute; width: 100%; height: 100%; top: 0px; background-color: #c3c3c3; z-index: 1000; opacity: 0.4;"><i class="fa fa-sticky-note" style=" font-size: 24px; z-index: 1005; position: absolute; top: 100px; left: 100px; color: red;"></i></div>
    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import { notify } from 'utils'

    export default {
        components: {
            LaddaButton,
            Datepicker,
            Selectize
        },

    	props: ['line', 'costing', 'project'],
        data: function () {
            return {
            	edit: false,
            	loading: false,
				users: []
            }
        },

        computed: {
        	'api': function() {
        		return process.env.VUE_APP_API_URL;
			},
			order () {
				return this.index + 1
			}

        },
        methods: {
            confirmRemoveGroup(groupId) {

                var that = this;

                this.$swal(
                    {
                        title: 'Confirm Delete',
                        html: 'Are you sure you want to remove the group "'+this.line.group.text+'" from this costing',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then(function() {
                        that.removeGroup(groupId);
                    }, function() {
                });


            },
            removeGroup(groupId) {
                var that = this;

                return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id+'/group', entity: {'group_id': groupId}, method: 'DELETE'}).then(
                    function(response) {
						that.$bus.$emit('reload')
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )
            },
            confirmRemoveFeature() {

                var that = this;

                this.$swal(
                    {
                        title: 'Confirm Delete',
                        html: 'Are you sure you want to remove the feature "'+this.line.name+'" from this costing',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then(function() {
                        that.removeFeature();
                    }, function() {
                });


            },
            removeFeature() {
                var that = this;

                return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id+'/lines/'+this.line.id, entity: {}, method: 'DELETE'}).then(
                    function(response) {
						that.$bus.$emit('reload')
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )
            },
            save: function() {

            	 var that = this;
                this.loading = true;

                return client({path: '/user-story-document/'+this.project.user_story_document_id+'/costing/'+this.costing.id+'/line/'+this.line.id, entity: this.line, method: 'PUT'}).then(
                    function(response) {
                    	that.$bus.$emit('reload')
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )

            	this.edit = false;
            }
        }
    }
</script>
